import { ComputedImage } from '@model/computed-image';

export class OgraphData {
  public url: string = '';
  // public type:string=''
  // public title:string=''
  // public description:string=''
  // public image:ComputedImage=null
}
